import React from 'react';

import { CallRecordings } from 'src/lib/resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { CallRecording } from '@ragu-components/ord-types';

const CallRecordingsList = React.lazy(async () =>
  import('./CallRecordingsList').then((module) => ({ default: () => <module.CallRecordingsList scope='admin' /> }))
);

export const callRecordingsResource: OrdResourceProps = {
  key: CallRecordings,
  name: CallRecordings,
  list: <CallRecordingsList />,
  options: {},
  recordRepresentation: (record: CallRecording): string =>
    `${record.caller_id_name ?? ''} (${record.caller_id_number ?? ''})`,
};
